(function(){
	let openBtOne = document.querySelector("#img-w-text-open-popup_one");
	let openBtTwo = document.querySelector("#img-w-text-open-popup_two");
	let body = document.querySelector("body");

	document.addEventListener("click", (el) => {
		// console.warn(" el ", el);
		// console.warn(" el.className ", el.srcElement.className);

		if (el.target == openBtOne){ // open  one pop-up
			document.querySelector("#one-popup.img-w-text-popup").classList.add("active");
			body.classList.add("lock");
		} else if (el.target == openBtTwo){ // open two pop-up
			document.querySelector("#two-popup.img-w-text-popup").classList.add("active");
			body.classList.add("lock");
		} else if (el.target.closest('.img-w-text-popup__close-btn')) { // the close pop-up by using the button
			document.querySelector(".img-w-text-popup.active").classList.remove("active");
			body.classList.remove("lock");
		} else if(el.srcElement.className == "img-w-text-popup active") { // the close pop-up by using the click
			document.querySelector(".img-w-text-popup.active").classList.remove("active");
			body.classList.remove("lock");
		}
	})
})();
